module.exports = __webpack_public_path__ + "img/spotted-orange-lily.f2fe68a5.jpg";